<template>
  <div ref="container">
    <a-modal :title="title" :width="500" :visible="visible" :maskStyle="{'top':'93px','left':'154px'}" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height:60%;">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="24" :sm="24">
            <a-form-item label="请选择模版名称">
              <a-select placeholder="请选择模版名称" showSearch optionFilterProp="children" v-decorator.trim="[ 'templateid', validatorRules.templateid]">
                <a-select-option v-for="(depot,index) in templateList" :value="depot.uuid" :key="index">
                  {{ depot.templateName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>
<script>
import { printApi, printgetAll } from '@/api/api'
export default {
  name: 'VendorModal',
  data() {
    return {
      title: '选择打印模版',
      visible: false,
      model: {},
      dataSource: [],
      loading: false,
      productInfo: {},
      templateList: [],
      templateid: '',
      form: this.$form.createForm(this),
      validatorRules: {
        templateid: {
          rules: [
            {
              required: true,
              message: '请选择模版名称!',
            },
          ],
        },
      },
    }
  },
  created() {},
  methods: {
    async add(e) {
      this.visible = true
      this.form.resetFields()
      this.getlist()
      if (e) {
        this.productDi = e.productDi
      }
    },
    async getlist() {
      const res = await printgetAll()
      if (res.code == 200) {
        this.templateList = res.data
      } else {
        this.$message.error(res.data || res.msg)
      }
    },
    async myHandleDetailPI(id) {
      let params = {
        code: this.productDi,
        templateId: id,
      }
      const res = await printApi(params)
      let panel = {
        panels: [
          {
            height: 40,
            width: 60,
            orient: 1,
            paperNumberDisabled: true,
            printElements: [],
          },
        ],
      }

      if (res.code == 200 && res.data.length != 0) {
        let list = res.data.filter((it) => {
          return (it.option = JSON.parse(it.option))
        })
        let printData = {}
        list.forEach((it) => {
          it.option.title = it.title
          printData[it.field] = it.testData
          if (it.option.qrcodeType) {
            it.option.textType = it.option.qrcodeType
          }
          panel.panels[0].printElements.push({
            options: it.option,
            printElementType: { title: '自定义文本', type: 'text' },
          })
        })
        let hiprintTemplate = this.$print(undefined, panel, printData, {
          styleHandler: () => {
            let css =
              '<link href="http://hiprint.io/Content/hiprint/css/print-lock.css" media="print" rel="stylesheet">'
            return css
          },
        })
      } else {
        this.$message.error(res.msg || res.data)
      }
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.myHandleDetailPI(values.templateid)
          this.handleCancel()
        }
      })
      // 触发表单验证
    },
    handleCancel() {
      this.close()
    },
  },
}
</script>
<style scoped>
</style>